module.exports = __webpack_public_path__ + "img/ios.3089448d.png";